import React from 'react';
import { FiDownload, FiSmartphone, FiCheck, FiAlertCircle } from 'react-icons/fi';
import './Download.css';

const Download = () => {
  // APK hosted on GitHub Releases (free, fast CDN, never expires)
  const downloadUrl = "https://github.com/manishmandal55/portfolio-app-releases/releases/download/v1.0.0/manish-mandal.apk";

  return (
    <section className="download section">
      <div className="container">
        <div className="section-title">
          <h2>Download App</h2>
          <p className="section-subtitle">Get my portfolio app on your phone</p>
        </div>

        <div className="download-content">
          <div className="phone-mockup">
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="phone-screen">
                <FiSmartphone className="phone-icon" />
                <span className="app-name">Manish Mandal</span>
              </div>
            </div>
          </div>

          <div className="download-info">
            <div className="app-badge">
              <span className="badge-android">Android</span>
            </div>
            
            <h3>Manish Mandal</h3>
            <p className="app-tagline">Portfolio App • Backend Developer</p>
            
            <div className="features-list">
              <div className="feature-item">
                <FiCheck className="feature-icon" />
                <span>View projects on the go</span>
              </div>
              <div className="feature-item">
                <FiCheck className="feature-icon" />
                <span>Browse skills & experience</span>
              </div>
              <div className="feature-item">
                <FiCheck className="feature-icon" />
                <span>Contact me directly</span>
              </div>
              <div className="feature-item">
                <FiCheck className="feature-icon" />
                <span>Beautiful dark mode interface</span>
              </div>
              <div className="feature-item">
                <FiCheck className="feature-icon" />
                <span>Works offline after first load</span>
              </div>
            </div>

            <a href={downloadUrl} className="download-btn" download>
              <FiDownload /> Download APK
            </a>

            <div className="app-meta">
              <span className="meta-item">Version 1.0.0</span>
              <span className="meta-divider">•</span>
              <span className="meta-item">~15 MB</span>
              <span className="meta-divider">•</span>
              <span className="meta-item">Android 6.0+</span>
            </div>
          </div>
        </div>

        <div className="install-instructions">
          <h4>📱 How to Install</h4>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-content">
                <h5>Download</h5>
                <p>Click the download button above to get the APK file</p>
              </div>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-content">
                <h5>Open File</h5>
                <p>Find the downloaded file and tap to open it</p>
              </div>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-content">
                <h5>Allow Install</h5>
                <p>Enable "Install from unknown sources" if prompted</p>
              </div>
            </div>
            <div className="step-card">
              <div className="step-number">4</div>
              <div className="step-content">
                <h5>Enjoy!</h5>
                <p>Open the app and explore my portfolio</p>
              </div>
            </div>
          </div>
        </div>

        <div className="security-note">
          <FiAlertCircle className="note-icon" />
          <div className="note-content">
            <strong>Safe to install</strong>
            <p>This app is built by me and hosted on Expo. It's completely safe and contains no malware or ads.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;

